import { DayButtonProps, Modifiers } from 'react-day-picker';
import styled, { DefaultTheme } from 'styled-components';

export const Root = styled.div`
  font-family: ${({ theme }) => theme.typography.fontFamily};
  width: fit-content;
`;

export const CaptionLabel = styled.div`
  font-weight: 700;
  padding: 0.5rem;
  position: relative;
  text-align: center;
`;

export const Weekday = styled.th`
  font-size: ${({ theme }) => theme.typography.body1.fontSize};
  font-weight: ${({ theme }) => theme.typography.text1.fontWeight};
  line-height: ${({ theme }) => theme.typography.text1.lineHeight};
  opacity: 0.5;
`;

export const MonthCaption = styled.th`
  align-items: center;
  display: flex;
  font-weight: ${({ theme }) => theme.typography.h4.fontWeight};
  justify-content: center;
`;

export const Months = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  position: relative;
`;

export const Month = styled.div`
  display: flex;
  flex-direction: column;

  &:not(:first-of-type) {
    margin-left: 2rem;
  }
`;

export const Week = styled.tr`
  margin-top: 0.5rem;
`;

export const Day = styled.td`
  height: 1.75rem;
  padding: 0.5rem;
  text-align: center;
  width: 2.125rem;
`;

const getDayBackgroundColorByModifier = (
  theme: DefaultTheme,
  { selected, today, range_start, range_end }: Modifiers,
): string => {
  if (selected) {
    return range_start || range_end
      ? theme.palette.button.background.secondary.base
      : theme.palette.button.background.primary.base;
  }

  if (today) {
    return theme.palette.commons.tonal.base;
  }

  return 'unset';
};

const getDayOpacityByModifier = ({ disabled, outside }: Modifiers): string => {
  if (disabled) {
    return '.3';
  }

  return outside ? '.55' : 'unset';
};

export const DayButton = styled.button<DayButtonProps>`
  background-color: ${({ theme, modifiers }) =>
    getDayBackgroundColorByModifier(theme, modifiers)};
  border: none;
  border-radius: 2rem;
  color: ${({ theme, modifiers }) =>
    modifiers.selected
      ? theme.palette.button.text.secondary.base
      : theme.palette.button.text.select.base};
  cursor: ${({ disabled }) => !disabled && 'pointer'};
  font-size: ${({ theme }) => theme.typography.body1.fontSize};
  font-weight: ${({ theme }) => theme.typography.body1.fontWeight};
  height: 1.75rem;
  line-height: ${({ theme }) => theme.typography.body1.lineHeight};
  opacity: ${({ modifiers }) => getDayOpacityByModifier(modifiers)};
  width: 2.125rem;

  :hover {
    background-color: ${({ theme, modifiers, disabled }) =>
      !disabled &&
      !modifiers.selected &&
      theme.palette.button.background.select.selected};
  }
`;
